import { pathnames, routing, type AppLocale } from "@/i18n/routing";

// Returns the localized `/cart` URL. Callers should render it as a plain
// `<a href>` (not next-intl `<Link>`) so navigation triggers a full document
// load — bypassing React Activity's preservation of the previous cart RSC
// payload under `cacheComponents`. See `docs/preserving-ui-state.md`.
export function getCartHref(locale: AppLocale): string {
  const cartPathnames = pathnames["/cart"];
  const localizedPath =
    typeof cartPathnames === "string" ? cartPathnames : cartPathnames[locale];
  const prefix = locale === routing.defaultLocale ? "" : `/${locale}`;
  return `${prefix}${localizedPath}`;
}
